// removed by extract-text-webpack-plugin
module.exports = {"left":"typeM__left___3DSuw breakPointM-textAlign-left","center":"typeM__center___rmurE breakPointM-textAlign-center","right":"typeM__right___1AcHY breakPointM-textAlign-right","top":"typeM__top___1iEth breakPointM-display-tableCell breakPointM-verticalAlign-top","middle":"typeM__middle___2FND- breakPointM-display-tableCell breakPointM-verticalAlign-middle","bottom":"typeM__bottom___20IV5 breakPointM-display-tableCell breakPointM-verticalAlign-bottom"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-align/Align/style/typeM.css
// module id = 81
// module chunks = 0 16